import allergyActions from './actions';
import storeResourceFactory from '../../libs/storeResourceFactory';

const dietsStore = storeResourceFactory('allergies', {});

const state = {
  ...dietsStore.state,
};

const actions = {
  initializeAllergies: dietsStore.request(allergyActions.initializeAllergies),
};

const mutations = {
  ...dietsStore.mutations,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./store/modules/allergies/index.js